{
  "title": "Gate Seal",
  "source": "Planescape - Adventures in the Multiverse",
  "levelAndSchool": "4th-Level abjuration",
  "level": 4,
  "castingTime": "1 minute",
  "range": "60 feet",
  "components": "V, S, M (a broken portal key, which the spell consumes)",
  "duration": "24 Hours",
  "description": [
    "You fortify the fabric of the planes within a 30-foot cube you can see within range. Within that area, portals close and can't be opened for the duration. Spells and other effects that allow planar travel or open portals such as gate or plane shift, fail if used to enter or leave the area. The cube is stationary.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the spell lasts until dispelled."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
